import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class AuthenticationService {
    httpOptions = {
        headers: new HttpHeaders({
            'Accept-Language': window.navigator.language
        })
    }

    constructor(private http: HttpClient) {
    }

    login(user) {
        return this.http.post<any>(AppConstants.SITE_URL+'authenticate', user, this.httpOptions);
    }

    user_register(user) {
        return this.http.post<any>(AppConstants.SITE_URL +'signup', user, this.httpOptions);
    }

    forget_password(user) {
        return this.http.post<any>(AppConstants.SITE_URL +'forgot_password', user, this.httpOptions);
    }

    reset_password(data) {
        return this.http.post<any>(AppConstants.SITE_URL +'check_reset_token', data, this.httpOptions);
    }

    reset_password_save(user) {
        return this.http.post<any>(AppConstants.SITE_URL +'password_admin/reset', user, this.httpOptions);
    }
 
    activate_account(user) {
        return this.http.post<any>(AppConstants.SITE_URL +'auth/activate_account', user, this.httpOptions);
    }


}



// WEBPACK FOOTER //
// /var/www/delios/delios-live/app/src/app/services/authentication.service.ts